import { inject, injectable, interfaces } from 'inversify';
import { action, makeObservable } from 'mobx';
import { IOverlayLoaderStore } from '../../../modules/common/OverlayLoader.store';
import { IErrorsStore } from './errors.store';

export interface IErrorsService {
  setUnauthorized: () => void;
  clearUnauthorized: () => void;
}

export namespace IErrorsService {
  export const $: interfaces.ServiceIdentifier<IErrorsService> = Symbol('ERRORS_SERVICE');
}

@injectable()
export class ErrorsService implements IErrorsService {
  constructor(
    @inject(IErrorsStore.$) private readonly store: IErrorsStore,
    @inject(IOverlayLoaderStore.$) private readonly overlayLoaderStore: IOverlayLoaderStore
  ) {
    makeObservable(this);
  }

  @action
  setUnauthorized = (): void => {
    if (this.store.isAuthorized) {
      this.store.setAuthorization(false);
      this.overlayLoaderStore.hideOverlay();
    }
  };

  @action
  clearUnauthorized = (): void => {
    this.store.setAuthorization(true);
  };
}
